import { render, staticRenderFns } from "./CvJdMatch.vue?vue&type=template&id=608b0886&"
import script from "./CvJdMatch.vue?vue&type=script&lang=js&"
export * from "./CvJdMatch.vue?vue&type=script&lang=js&"
import style0 from "./CvJdMatch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports